// extracted by mini-css-extract-plugin
export default {"vinHighlight":"vinHighlighting_vinHighlight__JXQAk"};